import TokenCallback from '@/pages/tokenCallback/TokenCallback'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/token')({
  component: RouteComponent,
})

function RouteComponent() {
  return <TokenCallback />
}
